var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBorderAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.5V0.5H21.5V21.5H0.5ZM19.1667 19.1667V12.1667H12.1667V19.1667H19.1667ZM19.1667 2.83333H12.1667V9.83333H19.1667V2.83333ZM2.83333 2.83333V9.83333H9.83333V2.83333H2.83333ZM2.83333 19.1667H9.83333V12.1667H2.83333V19.1667Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBorderAll);
export default __webpack_public_path__ + "static/media/icon_border_all.54c19dd49b2498df7501e326c3198211.svg";
export { ForwardRef as ReactComponent };